import { render, staticRenderFns } from "./BldDABug.vue?vue&type=template&id=4e72c2b4&scoped=true&"
import script from "./BldDABug.vue?vue&type=script&lang=js&"
export * from "./BldDABug.vue?vue&type=script&lang=js&"
import style0 from "./BldDABug.vue?vue&type=style&index=0&id=4e72c2b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e72c2b4",
  null
  
)

export default component.exports